(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["passepr-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
  var stage = gallery.querySelector('.pe-prod__stage-img');
  var thumbs = gallery.querySelectorAll('[data-thumb]');
  if (!stage || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      stage.classList.add('is-swapping');
      var swap = function () {
        stage.src = thumb.dataset.src;
        stage.srcset = thumb.dataset.srcset;
        stage.classList.remove('is-swapping');
      };
      window.setTimeout(swap, 120);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
